"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_link_1 = require("apollo-link");
const transform_1 = require("./transform");
class ArgumentFragmentLink extends apollo_link_1.ApolloLink {
    request(operation, forward) {
        if (!forward) {
            throw new Error("ArgumentFragmentLink needs one or more apollo-links to delegate");
        }
        operation.query = transform_1.transform(operation.query);
        return forward(operation);
    }
}
exports.ArgumentFragmentLink = ArgumentFragmentLink;
function createFragmentArgumentLink() {
    return new ArgumentFragmentLink();
}
exports.createFragmentArgumentLink = createFragmentArgumentLink;
//# sourceMappingURL=link.js.map